window.Products.HomeDecor.Coaster = function () {}
window.Products.HomeDecor.Coaster.inherits(window.Products.HomeDecor.HomeDecor)